import copy from 'copy-to-clipboard';

export const copyText = (text) => {
  copy(text, { format: 'text/plain' });
}